/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
} from './Lead';

/**
 * 
 * @export
 * @interface LeadsFindAllResponse
 */
export interface LeadsFindAllResponse {
    /**
     * 
     * @type {Array<Lead>}
     * @memberof LeadsFindAllResponse
     */
    data: Array<Lead>;
    /**
     * 
     * @type {number}
     * @memberof LeadsFindAllResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof LeadsFindAllResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof LeadsFindAllResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeadsFindAllResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the LeadsFindAllResponse interface.
 */
export function instanceOfLeadsFindAllResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function LeadsFindAllResponseFromJSON(json: any): LeadsFindAllResponse {
    return LeadsFindAllResponseFromJSONTyped(json, false);
}

export function LeadsFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadsFindAllResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(LeadFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function LeadsFindAllResponseToJSON(value?: LeadsFindAllResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(LeadToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

